const moment = require('moment');

export function onFilePicked (event) {
  const file = event.target.files[0] || null

  if (!file) { return }

  const imageName = file.name

  if (imageName.lastIndexOf('.') <= 0) {
    return
  }

  this.rawImage = event.target.files[0]
  this.imageCollection = event.target.files
  this.fileName = file.name

  const fileReader = new FileReader()

  /*fileReader.onload = function (evt) {
      var binary = '';
      var bytes = new Uint8Array(fileReader.result);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
      }
  }

  fileReader.readAsArrayBuffer(file);
  this.imageUrl = fileReader.result
  if (typeof (this.standAlone) !== 'undefined') {
    this.emitData()
  }*/

  fileReader.readAsDataURL(file)

  fileReader.addEventListener('load', () => {
    this.imageUrl = fileReader.result
    if (typeof (this.standAlone) !== 'undefined') {
      this.emitData()
    }
  })

  this.image = file
}

export function fileUploadInit () {
  this.$refs.fileInput.click()
}

export function trimText(string){
  var length = 30;
  if(string.length > 29){
    var trimmedString = string.substring(0, length)+'...';
  }else{
    var trimmedString = string;
  }
  return trimmedString;
}

export function trimJobText(string){
  var length = 200;
  if(string.length > 199){
    var trimmedString = string.substring(0, length)+' ....';
  }else{
    var trimmedString = string;
  }  
  return trimmedString;
}

export function trimProjectText(string){
  var length = 25;
  if(string.length > 24){
    var trimmedString = string.substring(0, length)+' ....';
  }else{
    var trimmedString = string;
  }  
  return trimmedString;
}

export function countryCodes() {
  var codes = [{"text": "+93"},{"text": "+358"},{"text": "+355"},{"text": "+213"},{"text": "+1684"},{"text": "+376"},{"text": "+244"},{"text": "+1264"},{"text": "+672"},{"text": "+1268"},{"text": "+54"},{"text": "+374"},{"text": "+297"},{"text": "+61"},{"text": "+43"},{"text": "+994"},{"text": "+1242"},{"text": "+973"},{"text": "+880"},{"text": "+1246"},{"text": "+375"},{"text": "+32"},{"text": "+501"},{"text": "+229"},{"text": "+1441"},{"text": "+975"},{"text": "+591"},{"text": "+387"},{"text": "+267"},{"text": "+55"},{"text": "+246"},{"text": "+673"},{"text": "+359"},{"text": "+226"},{"text": "+257"},{"text": "+855"},{"text": "+237"},{"text": "+1"},{"text": "+238"},{"text": "+345"},{"text": "+236"},{"text": "+235"},{"text": "+56"},{"text": "+86"},{"text": "+61"},{"text": "+57"},{"text": "+269"},{"text": "+242"},{"text": "+243"},{"text": "+682"},{"text": "+506"},{"text": "+225"},{"text": "+385"},{"text": "+53"},{"text": "+357"},{"text": "+420"},{"text": "+45"},{"text": "+253"},{"text": "+1767"},{"text": "+1849"},{"text": "+593"},{"text": "+20"},{"text": "+503"},{"text": "+240"},{"text": "+291"},{"text": "+372"},{"text": "+251"},{"text": "+500"},{"text": "+298"},{"text": "+679"},{"text": "+358"},{"text": "+33"},{"text": "+594"},{"text": "+689"},{"text": "+241"},{"text": "+220"},{"text": "+995"},{"text": "+49"},{"text": "+233"},{"text": "+350"},{"text": "+30"},{"text": "+299"},{"text": "+1473"},{"text": "+590"},{"text": "+1671"},{"text": "+502"},{"text": "+44"},{"text": "+224"},{"text": "+245"},{"text": "+592"},{"text": "+509"},{"text": "+379"},{"text": "+504"},{"text": "+852"},{"text": "+36"},{"text": "+354"},{"text": "+91"},{"text": "+62"},{"text": "+98"},{"text": "+964"},{"text": "+353"},{"text": "+44"},{"text": "+972"},{"text": "+39"},{"text": "+1876"},{"text": "+81"},{"text": "+44"},{"text": "+962"},{"text": "+7"},{"text": "+254"},{"text": "+686"},{"text": "+850"},{"text": "+82"},{"text": "+965"},{"text": "+996"},{"text": "+856"},{"text": "+371"},{"text": "+961"},{"text": "+266"},{"text": "+231"},{"text": "+218"},{"text": "+423"},{"text": "+370"},{"text": "+352"},{"text": "+853"},{"text": "+389"},{"text": "+261"},{"text": "+265"},{"text": "+60"},{"text": "+960"},{"text": "+223"},{"text": "+356"},{"text": "+692"},{"text": "+596"},{"text": "+222"},{"text": "+230"},{"text": "+262"},{"text": "+52"},{"text": "+691"},{"text": "+373"},{"text": "+377"},{"text": "+976"},{"text": "+382"},{"text": "+1664"},{"text": "+212"},{"text": "+258"},{"text": "+95"},{"text": "+264"},{"text": "+674"},{"text": "+977"},{"text": "+31"},{"text": "+599"},{"text": "+687"},{"text": "+64"},{"text": "+505"},{"text": "+227"},{"text": "+234"},{"text": "+683"},{"text": "+672"},{"text": "+1670"},{"text": "+47"},{"text": "+968"},{"text": "+92"},{"text": "+680"},{"text": "+970"},{"text": "+507"},{"text": "+675"},{"text": "+595"},{"text": "+51"},{"text": "+63"},{"text": "+64"},{"text": "+48"},{"text": "+351"},{"text": "+1939"},{"text": "+974"},{"text": "+40"},{"text": "+7"},{"text": "+250"},{"text": "+262"},{"text": "+590"},{"text": "+290"},{"text": "+1869"},{"text": "+1758"},{"text": "+590"},{"text": "+508"},{"text": "+1784"},{"text": "+685"},{"text": "+378"},{"text": "+239"},{"text": "+966"},{"text": "+221"},{"text": "+381"},{"text": "+248"},{"text": "+232"},{"text": "+65"},{"text": "+421"},{"text": "+386"},{"text": "+677"},{"text": "+252"},{"text": "+27"},{"text": "+211"},{"text": "+500"},{"text": "+34"},{"text": "+94"},{"text": "+249"},{"text": "+597"},{"text": "+47"},{"text": "+268"},{"text": "+46"},{"text": "+41"},{"text": "+963"},{"text": "+886"},{"text": "+992"},{"text": "+255"},{"text": "+66"},{"text": "+670"},{"text": "+228"},{"text": "+690"},{"text": "+676"},{"text": "+1868"},{"text": "+216"},{"text": "+90"},{"text": "+993"},{"text": "+1649"},{"text": "+688"},{"text": "+256"},{"text": "+380"},{"text": "+971"},{"text": "+44"},{"text": "+1"},{"text": "+598"},{"text": "+998"},{"text": "+678"},{"text": "+58"},{"text": "+84"},{"text": "+1284"},{"text": "+1340"},{"text": "+681"},{"text": "+967"},{"text": "+260"},{"text": "+263"}];
  codes.sort(GetSortOrder("text"));
  return codes;
}

function GetSortOrder(prop) {  
    return function(a, b) {  
        if (a[prop] > b[prop]) {  
            return 1;  
        } else if (a[prop] < b[prop]) {  
            return -1;  
        }  
        return 0;  
    }  
}  

export function jobStatus(status,assigned,active,createdAt,expired) {  
  const today = moment(new Date(), 'DD-MM-YYYY');  
  const createdD = new Date(createdAt);
  const createdM = createdD.getMonth();
  createdD.setMonth(createdM + 2);  
  const expiredate = moment(createdD);  

  if(expired == true) {
    return '<span style="color:red">Expired</span>';
  } else if(assigned == true) {
    return '<span style="color:blue">Assigned</span>';
  } else if(active == true) {
    return '<span style="color:green">Available</span>';
  } else if(active == false) {
    return '<span style="color:red">Inactive</span>';
  }
  /*if(active == false){
    return '<span style="color:red">Inactive</span>';
  } else if(assigned == false && today < expiredate){
    return '<span style="color:green">Available</span>';
  } else if(assigned == true && today < expiredate){
    return '<span style="color:green">Assigned</span>';
  } else if(today > expiredate){
    return '<span style="color:green">Expired</span>';
  }*/
}

export function trimDescription(string){
  var span = document.createElement('span');
  span.innerHTML = string;
  var text = span.textContent || span.innerText;  

  var length = 30;
  if(text.length > 29){
    var trimmedString = text.substring(0, length)+'...';
  }else{
    var trimmedString = text;
  }
  return trimmedString;
}

export function onVideoFilePicked (event) {
  const file = event.target.files[0] || null

  if (!file) { return }
  const videofileSize = file.size
  const kbytes = videofileSize / 1000
  const mbBytes = kbytes / 1000 

  if(mbBytes > 15) {
    this.image = file
    this.fileSize = mbBytes
    this.emitSize()
    return 
  }
  const imageName = file.name

  if (imageName.lastIndexOf('.') <= 0) {
    return
  }

  this.rawImage = event.target.files[0]
  this.imageCollection = event.target.files
  this.fileName = file.name
  this.fileSize = mbBytes
  
  const fileReader = new FileReader()

  fileReader.readAsDataURL(file)

  fileReader.addEventListener('load', () => {
    this.imageUrl = fileReader.result
    if (typeof (this.standAlone) !== 'undefined') {
      this.emitData()
    }
  })

  this.image = file
}

export function videofileUploadInit () {
  this.$refs.videofileInput.click()
}

export function trimTicketText(string){
  var length = 200;
  if(string.length > 199){
    var trimmedString = string.substring(0, length)+' ....';
  }else{
    var trimmedString = string;
  }  
  return trimmedString;
}